import { defineComponent as _defineComponent } from 'vue';
import CompanyLayout from '@/Layouts/Company.vue';
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import PhenologicalPhaseBadge from './PhenologicalPhaseBadge.vue';
import CropManagementDetails from './CropManagement/Details.vue';
import IrrigationWaterDataTable from './IrrigationWaterData/Table.vue';
import SoilData from './SoilData/Table.vue';
import LeavesData from './LeavesData/Table.vue';
import SymptomsData from './SymptomRecords/Table.vue';
import Devices from './Devices/Table.vue';
import PlotList from './Plots/List.vue';
import Dashboard from './Management/Dashboard.vue';
import LinkButton from '@/Components/LinkButton.vue';
import { useRoute } from '@/Plugins/ziggy';
import { usePageProps } from '@/Plugins/page-props';
import { trans, transChoice } from 'laravel-vue-i18n';
import NutritionBalancesTable from './NutritionBalances/Table.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'Management',
    props: {
        orchard: {
            type: Object,
            required: true,
        },
        irrigations: {
            type: Object,
            required: true,
        },
        fertilizations: {
            type: Object,
            required: true,
        },
    },
    setup(__props, { expose }) {
        expose();
        const route = useRoute();
        const user = usePageProps();
        const company = user.company();
        const routePrefix = user.isAdmin() ? 'admin.companies.' : '';
        const __returned__ = { route, user, company, routePrefix, CompanyLayout, get TabView() { return TabView; }, get TabPanel() { return TabPanel; }, PhenologicalPhaseBadge, CropManagementDetails, IrrigationWaterDataTable, SoilData, LeavesData, SymptomsData, PlotList, Dashboard, LinkButton, get trans() { return trans; }, get transChoice() { return transChoice; }, NutritionBalancesTable };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
